// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__ZvkYN","clinicsSelect":"TableHeading_clinicsSelect__1cGki"};